import React, { useCallback } from "react";
import FormFieldInputNew from "./FormFieldInputNew";
import styles from "./FormFieldUploadFile.module.scss";
import inputStyles from "./FormFieldInputNew.module.scss";
import { readFileFromEvent } from "../../utils";
import classNames from "classnames";
import { UploadIcon } from "@netapp/bxp-design-system-react/icons/monochrome";

export default ({ form, name, hideText, disabled, showError: _showError, ...rest }) => {
    const handleFormChange = form.handleFormChange;
    const showError = !_.isUndefined(_showError) ? _showError : (form.submissionAttempted && form.formErrors[name]);

    const readFile = useCallback(async (e) => {

        const file = await readFileFromEvent(e);

        handleFormChange(file, {
            name
        });

        e.target.value = ''
    }, [handleFormChange])

    return <FormFieldInputNew
        {...rest}
        showError={showError}
        form={form}
        value={form.formState[name]?.fileName || ""}
        name={name}
        disabled={disabled}
        type="text"
        readOnly
        inputClassName={(disabled || showError) ? undefined : styles["input"]}
        inputButtons={<div className={classNames(inputStyles["form-field-input-button"], styles["base"], { [inputStyles["icon-only"]]: hideText})}>
            <input disabled={disabled} type="file" onChange={readFile}/>
            <UploadIcon/>
            {!hideText && <span className={styles['label']}>Upload</span>}
        </div>}
    />
};